// Vuex constants
export const TOKEN = "token"
export const REFRESH_TOKEN = "refresh_token"
export const TOKEN_EXPIRES = "expires"
export const USER_DATA = "userData"

export const LANGUAGE = "language"







